import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_UTILS } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	certificateValidateSuccess,
	certificateValidateFailure,
} from './actions';

function* certificateValidateRequest(request: ReducerAction) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_UTILS,
		`/mtls/${CHANNEL}/client-certificate/validate`,
		payload,
	);

	if (
		response.status === 200 ||
		response.status === 201 ||
		response.status === 302
	) {
		yield put(certificateValidateSuccess(response));
	} else if (response.error) {
		yield put(certificateValidateFailure(response.message));
	}
}

export default all([
	takeLatest(Types.CERTIFICATE_VALIDATE_REQUEST, certificateValidateRequest),
]);
